import lodash from 'lodash';
import { makeAutoObservable, runInAction } from "mobx";

import { ChatMessageCreatedBroadcast, ChatMessagesReadBroadcast } from 'shared/broadcasts';
import { chatMessagesUnreadCountQuery } from 'shared/queries';

import { BroadcastModule } from "./BroadcastModule";

class ChatMessagesModuleClass {
    unreadCount = 0;
    isSubscribed = false;

    chatMessageCreatedBroadcast = new ChatMessageCreatedBroadcast(() => {
        this.fetchUnreadCount();
    });

    chatMessagesReadBroadcast = new ChatMessagesReadBroadcast(() => {
        this.fetchUnreadCount();
    });

    debouncedFetchUnreadCount = lodash.debounce(async () => {
        const response = await chatMessagesUnreadCountQuery();
        runInAction(() => {
            if (response.isSuccess && response.data) {
                this.unreadCount = response.data.value;
            }
        });
    }, 400);

    constructor() {
        makeAutoObservable(this, {
            isSubscribed: false,
            chatMessageCreatedBroadcast: false,
            chatMessagesReadBroadcast: false,
            debouncedFetchUnreadCount: false,
            subscribe: false,
            unsubscribe: false,
        });
    }

    fetchUnreadCount = () => {
        this.debouncedFetchUnreadCount();
    }

    connect = () => {
        this.subscribe();
        this.fetchUnreadCount();
    }

    reset = () => {
        this.unsubscribe();
        this.debouncedFetchUnreadCount.cancel();
        this.unreadCount = 0;
    }

    subscribe = () => {
        if (this.isSubscribed) {
            this.unsubscribe();
        }
        BroadcastModule.subscribe(this.chatMessageCreatedBroadcast);
        BroadcastModule.subscribe(this.chatMessagesReadBroadcast);
        this.isSubscribed = true;
    }

    unsubscribe = () => {
        if (!this.isSubscribed) {
            return;
        }
        BroadcastModule.unsubscribe(this.chatMessageCreatedBroadcast);
        BroadcastModule.unsubscribe(this.chatMessagesReadBroadcast);
        this.isSubscribed = false;
    }
}

export const ChatMessagesModule = new ChatMessagesModuleClass();
